import { Component, OnDestroy } from '@angular/core';
import { REFERRAL_COMPONENTS } from '../../../../constants/referral.constants';
import { ActivatedRoute } from '@angular/router';
import { ErrorMessages } from '../../../../config/error-messages';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { Config } from '../../../../config/config';
import { ServiceRouter } from '../../../../services/core/http-service-router.service';
import { METHOD_TYPE } from '../../../../constants/service.constants';
import { Environment } from '../../../../config/environment';
import { Subscription } from 'rxjs';

/**
 * Pending appointment request component
 */
@Component({
	selector: 'app-pending-appointment-requests',
	templateUrl: './pending-appointment-requests.component.html',
	styleUrls: ['./pending-appointment-requests.component.scss'],
})
export class PendingAppointmentRequestsComponent implements OnDestroy {
	/** Referral data */
	data: any;
	/** Current referral flag */
	isCurrentReferral: boolean = false;
	/** Referral component constants */
	referralComponents: any = REFERRAL_COMPONENTS;
	/** Data carrier subscription */
	subscriptions: Subscription[] = [];

	// isCurrentReferral: Boolean = false;
	/** Referral no data message */
	noDataMsg: string;
	/** Referral no data flag */
	noData: boolean = false;

	/**
	 * Pending appointment request constructor
	 * @param activatedRoute Contains the information about route associated
	 * @param errorMsg Error messages
	 * @param spinner Spinner component
	 * @param config Config file that holds the service end points
	 * @param serviceRouter Service router
	 * @param environment Environment file that supplies env values
	 */
	constructor(
		private activatedRoute: ActivatedRoute,
		private errorMsg: ErrorMessages,
		private spinner: SpinnerComponent,
		private config: Config,
		private serviceRouter: ServiceRouter,
		private environment: Environment
	) {
		this.subscriptions.push(
			this.activatedRoute.params.subscribe(params => {
				try {
					this.isCurrentReferral = params.section === 'current';
				} catch (Exception) {}
				if (this.isCurrentReferral) {
					this.getPendingApptsForCurrentReferral();
				} else {
					this.getPendingApptsForPastReferral();
				}
			})
		);
	}

	/**
	 * Retrieve current referral pending appointment list
	 */
	getPendingApptsForCurrentReferral() {
		this.data = '';
		this.spinner.startLoader();
		this.subscriptions.push(
			this.serviceRouter
				.makeRequest(
					this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
					this.config.url.referralApi.getCurrentReferrals + '?category=pending_appointments',
					METHOD_TYPE.SECURED_GET,
					''
				)
				.subscribe(
					(response: any) => {
						this.spinner.stopLoader();
						this.data = response;
						if (!this.data || !this.data.category || this.data.category.length === 0) {
							this.noData = true;
							this.noDataMsg = this.errorMsg.noData.appointmentRequests;
						}
					},
					err => {
						this.spinner.stopLoader();
						this.noData = true;
						this.noDataMsg = this.errorMsg.noData.appointmentRequests;
					}
				)
		);
	}

	/**
	 * Retrieve past referral pending appointment list
	 */
	getPendingApptsForPastReferral() {
		this.data = '';
		this.spinner.startLoader();
		this.subscriptions.push(
			this.serviceRouter
				.makeRequest(
					this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
					this.config.url.referralApi.getPastReferrals + '?category=pending_appointments',
					METHOD_TYPE.SECURED_GET,
					''
				)
				.subscribe(
					(response: any) => {
						this.spinner.stopLoader();
						this.data = response;
						if (!this.data || !this.data.category || this.data.category.length === 0) {
							this.noData = true;
							this.noDataMsg = this.errorMsg.noData.appointmentRequests;
						}
					},
					err => {
						this.spinner.stopLoader();
						this.noData = true;
						this.noDataMsg = this.errorMsg.noData.appointmentRequests;
					}
				)
		);
	}

	/**
	 * Prints referral information
	 */
	print() {
		window.print();
	}

	/**
	 * Destroys the component
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
		this.subscriptions = [];
	}
}
